import { render, staticRenderFns } from "./FooterSocialMedia.vue?vue&type=template&id=f87896b4&scoped=true&"
import script from "./FooterSocialMedia.vue?vue&type=script&lang=js&"
export * from "./FooterSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87896b4",
  null
  
)

export default component.exports